import { useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import { ICreateSeederOrderPayload, ISeederOrder } from "../types/seederOrders";

const API = process.env.REACT_APP_API;

const useCreateSeederOrder = () => {
  const fetch = useFetch();
  const queryClient = useQueryClient();

  return useMutation(
    (payload: ICreateSeederOrderPayload) => {
      return fetch(`${API}/api/semeadora/orders/`, {
        method: "POST",
        body: payload,
      }) as Promise<ISeederOrder>;
    },
    {
      onSuccess: () => {
        // Invalidar cache para recarregar a lista de pedidos
        queryClient.invalidateQueries(["seeder-orders"]);
      },
    },
  );
};

export default useCreateSeederOrder;
